<template>
    <div v-if="!loading && counters && counters.length">
        <h5 class="mb-2 titlecolor">{{ $t('partner.job.counters') }}</h5>

        <v-data-table v-if="!isPhoneBool" dense :headers="counterTableHeaders" :items="counters" hide-default-footer
            disable-pagination item-key="Id">

            <template v-slot:item.Value="{ item }">
                <v-text-field v-if="!readonly" v-model="item.editValue" :loading="item.loading" single-line
                    variant="outlined" density="compact" hide-details="auto" clearable class="mt-0 pt-0"
                    :error="item.errors && item.errors.length > 0" :error-messages="item.errors"
                    @blur="setCounter(item)">
                </v-text-field>
                <template v-else>
                    {{ item.Value }}
                </template>
            </template>
        </v-data-table>

        <v-row v-else no-gutters>
            <v-col v-for="(item, index) in counters" :key="'counter-' + index" cols="12">
                <b class="mb-1 titlecolor" v-text="item.Name" />
                <v-text-field v-if="!readonly" v-model="item.editValue" :loading="item.loading" single-line
                    variant="outlined" density="compact" :label="item.Name"
                    :hint="item.LastValue ? ('Was ' + item.LastValue) : undefined" :placeholder="item.LastValue"
                    persistent-placeholder clearable class="mt-0 pt-0" :error="item.errors && item.errors.length > 0"
                    :error-messages="item.errors" @blur="setCounter(item)">
                </v-text-field>
            </v-col>
        </v-row>

        <v-progress-linear v-if="loading" indeterminate color="primary" height="1">
        </v-progress-linear>
    </div>
</template>


<script>
import http from "@/api/client";

export default {
    name: "MachineCounters",
    components: {
    },
    props: {
        machineid: {
            type: Number,
            required: true
        },
        readonly: Boolean,
    },

    data() {
        return {
            loading: true,
            showCounters: true,
            counters: [],
        }
    },

    mounted() {
        this.getCounters();
    },

    methods: {
        getCounters() {
            this.loading = true;
            return http()
                .get(`api2/partner/machinecounter/${this.machineid}`)
                .then((response) => {
                    this.counters = response.data.map((counter) => ({
                        ...counter,
                        editValue: counter.Value,
                        loading: false,
                        errors: null,
                    }));
                    this.loading = false;
                });
        },

        async setCounter(counter) {
            if (counter.editValue != counter.Value) {
                counter.Value = counter.editValue;
                counter.loading = true;
                await http()
                    .put(`api2/partner/machinecounter/`, counter)
                    .then(() => {
                        counter.errors = null;
                    })
                    .catch((error) => {
                        if (error.status != 204) {
                            console.error(error);
                            counter.errors = 'Error saving value.';
                        }
                    })
                    .finally(() => {
                        counter.loading = false;
                    });
            }
        },
    },

    computed: {
        counterTableHeaders() {
            return [
                { title: this.$t('partner.job.counter_name'), key: 'Name', sortable: false, align: 'start' },
                { title: this.$t('partner.job.counter_todays_value'), key: 'Value', sortable: false, align: 'start' },
                { title: this.$t('partner.job.counter_previous_value'), key: 'LastValue', sortable: false, align: 'end' },
            ];
        },
    },

    watch: {},
};
</script>


<style lang="css" scoped></style>